/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SidecarSchema
 */
export interface SidecarSchema {
    /**
     * 
     * @type {string}
     * @memberof SidecarSchema
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SidecarSchema
     */
    container: string;
    /**
     * 
     * @type {string}
     * @memberof SidecarSchema
     */
    command: string;
    /**
     * 
     * @type {boolean}
     * @memberof SidecarSchema
     */
    ignoreEntrypoint?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof SidecarSchema
     */
    ports?: Array<number>;
}

/**
 * Check if a given object implements the SidecarSchema interface.
 */
export function instanceOfSidecarSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "container" in value;
    isInstance = isInstance && "command" in value;

    return isInstance;
}

export function SidecarSchemaFromJSON(json: any): SidecarSchema {
    return SidecarSchemaFromJSONTyped(json, false);
}

export function SidecarSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SidecarSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'container': json['container'],
        'command': json['command'],
        'ignoreEntrypoint': !exists(json, 'ignore_entrypoint') ? undefined : json['ignore_entrypoint'],
        'ports': !exists(json, 'ports') ? undefined : json['ports'],
    };
}

export function SidecarSchemaToJSON(value?: SidecarSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'container': value.container,
        'command': value.command,
        'ignore_entrypoint': value.ignoreEntrypoint,
        'ports': value.ports,
    };
}

